module.exports = __webpack_public_path__ + "static/media/php.b4230f5d.png";